import { useState, useEffect } from "react"; 
import { doc, getDoc } from "firebase/firestore"; 
import { db } from "../firebase/config"; 
import { useAuth } from "../firebase/auth";
import { useNavigate } from "react-router-dom"; 
import { Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import NavbarWithLogout from "../ui/NavbarWithLogout";

function WaitingForApproval() { 

  const { currentUser } = useAuth(); // Get the current user 
  const [approved, setApproved] = useState(false); // Approval status 
  const [message, setMessage] = useState("Your account is pending admin approval."); 
  const navigate = useNavigate(); 

  useEffect(() => { 
    // Function to check if the user has been approved 
    const checkApprovalStatus = async () => { 
      if (currentUser) { 
        const userRef = doc(db, "users", currentUser.uid); 
        const userDoc = await getDoc(userRef); 
        if (userDoc.exists()) { 
          const userData = userDoc.data(); 
          if (userData.approved) { 
            setApproved(true); 
            setMessage("Your account has been approved! Redirecting to the faculty dashboard..."); 
            setTimeout(() => { 
              navigate("/faculty/dashboard"); // Redirect to faculty/admin dashboard after approval 
            }, 3000); 
          } 
        } 
      } 
    }; 
    // Check approval status every 10 seconds 
    const interval = setInterval(checkApprovalStatus, 10000); 
    return () => clearInterval(interval); 

  }, [currentUser, navigate]); 

  

  return ( 
    <>
    <Container className="bg-white p-5 mt-5 shadow-sm rounded"> 
      <Row className="justify-content-md-center"> 
        <Col md={6} className="text-center"> 
          <h2 className="my-4">Waiting for Admin Approval</h2> 
          <Alert variant={approved ? "success" : "warning"}>{message}</Alert> 
          {!approved && ( 
            <> 
              <Spinner animation="border" role="status"> 
                <span className="sr-only">Loading...</span> 
              </Spinner> 
              <p className="mt-3">Please wait while an admin reviews your account.</p> 
            </> 
          )} 
        </Col> 
      </Row> 
    </Container> 
    </>
  ); 
}  

export default WaitingForApproval; 